import { render, staticRenderFns } from "./dashboard_page.vue?vue&type=template&id=40d3eb8d"
import script from "./dashboard_page.vue?vue&type=script&lang=js"
export * from "./dashboard_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports